import { Grid, useMediaQuery } from "@mui/material";
import VideoSection from "Pages/Landing/components/VideoSection/VideoSection";
import React, { useEffect, useState } from "react";
import { COLORS } from "theme";
import ChargingLocation from "./ChargingLocation";
import ChargingOptions from "./ChargingOptions";

import Sections from "Pages/Hiload/components/Sections/Sections";
import Euler from "assets/euler.png";

import { apiClient } from "api/apiClient";
import { sortData } from "utils";
import { Helmet } from "react-helmet";
import MetaTags from "ReusableComponents/MetaTags/MetaTags";
import { useLanguage } from "LanguageContext";
import { useTranslation } from "react-i18next";

const ChargingNetowrk = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const medium = useMediaQuery("(max-width: 1200px)");
  const { t } = useTranslation();

  const [subHeading, setSubHeading] = useState("");
  const [videoUrl, setVideoUrl] = useState();

  const [allfeatures, setAllFeatures] = useState([]);
  const [sections, setSections] = useState([]);
  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    apiClient.getCharginNetworkSubHeading(selectedLanguage).then((res) => {
      setSubHeading(res.data[0].attributes.subHeading);
      // setVideoUrl(res.data[0].attributes.video.data.attributes.url);
    });
    apiClient.getChargingNetworkFeatures(selectedLanguage).then((res) => {
      setAllFeatures(res.data);
    });
    apiClient.getChargingNetworkSections(selectedLanguage).then((res) => {
      const sorted = sortData(res.data);
      setSections(sorted);
    });
    apiClient.getVideoById("hiload_charging_network").then((res) => {
      setVideoUrl(res.data[0]?.attributes?.url);
    });
  }, []);
  return (
    <>
      <Grid item xs={12} style={{ padding: 0, marginTop: 71 }}>
        <VideoSection
          isOverlay
          videoUrl={videoUrl}
          formChargingNetwork
          subHeading={subHeading}
          small={small}
        />
      </Grid>
      <Grid item xs={12} style={{ padding: 0, background: COLORS.lightBlack }}>
        <ChargingOptions
          allfeatures={allfeatures}
          small={small}
          medium={medium}
        />
      </Grid>
      <Grid item xs={12} style={{ padding: 0, background: COLORS.black }}>
        <ChargingLocation small={small} medium={medium} />
      </Grid>

      {sections.map((item, i) => (
        <Grid
          item
          xs={12}
          style={{ padding: 0, zIndex: 1, background: COLORS.lightBlack }}
          key={item.id}
        >
          <Sections
            isExtra
            small={small}
            medium={medium}
            formChargingNetwork
            inverse={i % 2 !== 0}
            img={
              small
                ? item?.attributes["media_mobile"]?.data?.attributes?.url
                : item?.attributes["media"]?.data?.attributes?.url
            }
            alt={item?.attributes.media?.data?.attributes?.alternativeText}
            color={COLORS.lightGrey}
            name={item.attributes.title}
            subtitle={item.attributes.subtitle}
            description={item?.attributes?.description}
            features={[
              {
                id: 1,
                title: item?.attributes?.feature1,

                img: item?.attributes?.feature1image?.data?.attributes?.url,
                alt: item?.attributes?.feature1image?.data?.attributes
                  ?.alternativeText,
              },
              {
                id: 2,
                title: item?.attributes?.feature2,
                img: item?.attributes?.feature2image?.data?.attributes?.url,
                alt: item?.attributes?.feature2image?.data?.attributes
                  ?.alternativeText,
              },
              {
                id: 3,
                title: item?.attributes?.feature3,
                img: item?.attributes?.feature3image?.data?.attributes?.url,
                alt: item?.attributes?.feature3image?.data?.attributes
                  ?.alternativeText,
              },
              {
                id: 4,
                title: item?.attributes?.feature4,
                img: item?.attributes?.feature4image?.data?.attributes?.url,
                alt: item?.attributes?.feature4image?.data?.attributes
                  ?.alternativeText,
              },
            ]}
          />
        </Grid>
      ))}
      <Helmet>
        <title>
          {t("Electric Vehicle Charging Station Solutions | Euler Motors")}
        </title>
        <link rel="canonical" href="https://www.eulermotors.com/en/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/te/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/charging-network" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/charging-network" />


        <link
          rel="publisher"
          href="https://www.eulermotors.com/charging-network"
        />
        <meta
          name="title"
          content={t(
            "Electric Vehicle Charging Station Solutions | Euler Motors"
          )}
        />
        <meta
          name="description"
          content={t(
            "EV Charging solutions made easier with Euler HiLoad EV's robust Charging stations network to help you deliver more. Electric auto charging stations."
          )}
        />
        ​
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.eulermotors.com/charging-network"
        />
        <meta
          property="og:title"
          content="Electric Vehicle Charging Station | DC Fast Charging Hubs | Euler Motors"
        />
        <meta
          property="og:description"
          content="Concerned about finding charging stations or charging hubs for your electric three wheelers? With Euler Motors EV charging solutions, charge your vehicle at the convenience of your home or on the go."
        />
        <meta property="og:image" content={Euler} />
        ​
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.eulermotors.com/charging-network"
        />
        <meta
          property="twitter:title"
          content="Electric Vehicle Charging Station | DC Fast Charging Hubs | Euler Motors"
        />
        <meta
          property="twitter:description"
          content="Concerned about finding charging stations or charging hubs for your electric three wheelers? With Euler Motors EV charging solutions, charge your vehicle at the convenience of your home or on the go."
        />
        <meta property="twitter:image" content={Euler} />
        <MetaTags link={"https://www.eulermotors.com/charging-network"} />
      </Helmet>
    </>
  );
};

export default ChargingNetowrk;
